// ** React Imports
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "../../../../assets/navItems.css";
import logo from "../../../../assets/img/smartStudyLogo.svg";
// import logoShort from "../../menu/icons/logoShort.PNG";
import logoShort from "../../menu/icons/icon.svg";
// ** Icons Imports
import { Disc, X, Circle } from "react-feather";
import arrowLeft from "../../../../../assets/images/tablesImg/arrow_left.png";
import arrowRight from "../../../../../assets/images/tablesImg/arrow_right.png";
// ** Config
import themeConfig from "@configs/themeConfig";
import { useSelector, useDispatch } from "react-redux";
const VerticalMenuHeader = (props) => {
    // ** Props
    const {
        menuCollapsed,
        setMenuCollapsed,
        setMenuVisibility,
        setGroupOpen,
        menuHover,
    } = props;

    const [imgSrc, setImgSrc] = useState(arrowLeft);
    const [logoSrc, setLogoSrc] = useState(true);
    const layoutStore = useSelector((state) => state.layout);

    // ** Reset open group
    useEffect(() => {
        if (!menuHover && menuCollapsed) setGroupOpen([]);
    }, [menuHover, menuCollapsed]);

    // ** Menu toggler component
    const Toggler = () => {
        if (!menuCollapsed) {
            return (
                <div
                    data-tour="toggle-icon"
                    className="text-primary toggle-icon d-none d-xl-flex arrowsDiv"
                    onClick={() => {
                        setImgSrc(arrowRight);
                        setMenuCollapsed(true);
                        setLogoSrc(false);
                    }}
                >
                    <img src={imgSrc} alt="arrowRight" />
                </div>
            );
        } else {
            return (
                <div
                    data-tour="toggle-icon"
                    className="text-primary toggle-icon d-none d-xl-flex arrowsDiv"
                    onClick={() => {
                        setImgSrc(arrowLeft);
                        setLogoSrc(true);
                        setMenuCollapsed(false);
                    }}
                >
                    <img src={imgSrc} alt="arrowLeft" />
                </div>
            );
        }
    };
    return (
        <div
            className="navbar-header "
            style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px",
                padding: "20px 0",
                boxShadow: "-3px 0px 3px #00000029",
            }}
        >
            <ul className="nav  flex-row">
                <li className="nav-item me-auto">
                    <NavLink to="/home" className="navbar-brand">
                        <div className="brand-logo">
                            <img
                                src={
                                    menuCollapsed
                                        ? logoShort
                                        : themeConfig.app.appLogoImage
                                }
                                alt="logo"
                                id="smartLogoLong"
                                className={menuCollapsed ? "mt-1" : ""}
                            />
                        </div>
                    </NavLink>
                </li>
                <li className="nav-item nav-toggle">
                    <div className="nav-link modern-nav-toggle cursor-pointer  closeToggle">
                        <X
                            onClick={() => {
                                setMenuVisibility(false);
                            }}
                            className="toggle-icon icon-x d-block d-xl-none"
                            size={20}
                        />
                    </div>
                </li>
            </ul>
            <Toggler />
        </div>
    );
};

export default VerticalMenuHeader;
